(function () {
    var tableOfContent = {
        $moreAccessOptionsLink: $('.more-access-btn'),
        $previewLink: $('.preview_button'),
        $previewAndAccessOptionsContainer: $('.preview-and-access-options-links'),
        $robbin: $('.robbin'),

        init: function () {
            if (tableOfContent.$previewLink.length) {
                if (tableOfContent.$robbin.length) {
                    tableOfContent.$robbin.show();
                }

                if (
                    tableOfContent.$moreAccessOptionsLink.length &&
                    tableOfContent.$previewAndAccessOptionsContainer.length
                ) {
                    tableOfContent.$previewAndAccessOptionsContainer
                        .append('<a onclick="UX.tableOfContent.previewThisBook()">Preview this book</a>')
                        .append(' or find ')
                        .append('<a onclick="UX.tableOfContent.moreAccessOptions()">more access options</a>');
                }
            }
        },

        previewThisBook: function () {
            tableOfContent.$previewLink.click();
        },

        moreAccessOptions: function () {
            tableOfContent.$moreAccessOptionsLink.click();
        },
    };
    UX.tableOfContent = tableOfContent;
})();
